import { decode, encode } from 'html-entities';

export default {
	decode: decode,
	encode: encode
};
